import { css } from "@emotion/react";
import { bpoints } from "../../../../../Utils";

export function buro1CSS() {
    return css`
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        padding-bottom: 5rem;

        form {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            max-width: 1200px; // Ajusta este valor según tus necesidades
            margin: 0 auto;
              .ButtonWithShadow{
                display: flex;
                flex-direction: column;
                gap: 2rem;
                width: 100%;
                align-items: center;

                .Green{
                    background-color: #1FDD8F;
                    color: white;
                    font-size: calc(0.4rem + 0.7vw);
                    border-radius: 17px !important;
                    border: unset !important;
                    
                    width: 50%;
                    padding: 0 6rem;
                    :hover{
                        background-color: #2ad690;
    
                    }
                }
                .Shadow{
                    width: 50%;
                    height: 55px;
                    border-radius: 467px;
                    background: radial-gradient(50.94% 44.66% at 49.86% 50.14%, rgba(0, 0, 0, 0.14) 0%, rgba(217, 217, 217, 0.00) 100%);
                }
            }
        }

        .ResponsiveContainer {
            display: flex;
            // flex-wrap: wrap;
            gap: 15px;
            justify-content: space-between;
        }

        .Background {
            width: 100%;
        }

        .TopText {
            width: 100%;
            text-align: center;
        }

        .InputsSection {
            display: flex;
            flex-direction: column;
            gap: 10px;
            width: 100%;
        }

        .TextInput, .Dropdown {
            width: 100%;
        }

        .Dropdown{
            background-color: transparent;
            border-radius: 17px;
            border-color: #34C6F1;
            border-width: 1.5px;
            width: 100%;
            
            .p-inputtext{
                padding: 1rem 1.4rem;
                letter-spacing: 0.46px;
            }
            input{
                background-color: transparent;
                width: 100%;
                padding: 1rem 1.4rem;
                font-family: 'Neue Haas Grotesk Display Pro' !important;
                font-style: normal;
                font-weight: 600;
                letter-spacing: 0.46px;
                color: black;
            }

            .p-placeholder{
                color: #A7A9AC;
                font-weight: 500;
            }

            *{

                font-family: 'Neue Haas Grotesk Display Pro' !important;
                font-size: calc(0.2rem + 0.7vw);

                @media (max-width: ${bpoints.tablet.w}px){
                    font-size: calc(0.8rem + 1vw);
                }
            }
        }

           .TextInput{
            background-color: transparent;
            border-radius: 17px;
            border-color: #34C6F1;
            border-width: 1.5px;
            width: 100%;
            padding: 1rem 1.4rem;

            font-family: 'Neue Haas Grotesk Display Pro' !important;
            font-size: calc(0.2rem + 0.7vw);
            font-style: normal;
            font-weight: 600;
            letter-spacing: 0.46px;
            color: black;
            
            @media (max-width: ${bpoints.tablet.w}px){
                font-size: calc(0.8rem + 1vw);
            }

            ::placeholder{
                font-weight: 500;
                color: #A7A9AC;
            }

        }

        @media (max-width: 768px) {
            .ResponsiveContainer {
                flex-direction: column;
            }

            .InputsSection {
                width: 100%; /* Para dividir en dos columnas en pantallas grandes */
            }
        }


        .ButtonWithShadow1{
                display: flex;
                justify-content: flex-start;
                width: 80%;
            }

            .Green{
                    background-color: #1FDD8F;
                    color: white;
                    font-size: calc(0.4rem + 0.7vw);
                    border-radius: 17px !important;
                    border: unset !important;
    
                    width: fit-content;
                    :hover{
                        background-color: #2ad690;
    
                    }
                }
        
        .Background{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: -1;
            
        }

        .InfoContainer{
            display: flex;
            flex-direction: row;
            gap: 1rem;
            padding: 0 1rem;

            @media (max-width: 768px){
                flex-direction: column;
                gap: 0.5rem;
            }
                div{
                  min-width: 250px;
                    max-width: 320px;
                }
            }

            .col{
                display: flex;
                justify-content: center;
                align-items: flex-end;
                text-align: center;

                img{
                    width: calc(0.9rem + 5vw);
                }

                .FirstImg{
                    width: calc(0.2rem + 3vw);
                }

            }

            .BlueLineContainer{
                padding-left: 4%;
                padding-right: 4%;

                .BlueLine{
                    width: 100%;
                    height: 1px;
                    background: #34C6F1;
                }

            }

            
            .GreenTextContainer{
                color: #1FDD8F;
                font-family: 'Neue Haas Grotesk Display Pro';
                font-size: calc(0.5rem + 0.8vw);
                font-style: normal;
                font-weight: 600;
                line-height: 126.923%;

                padding-left: 2%;
                padding-right: 2%;
            }

            .BlackTextContainer{
                color: #000;
                font-family: 'Neue Haas Grotesk Display Pro';
                font-size: calc(0.2rem + 0.8vw);
                font-style: normal;
                font-weight: 500;

                padding-left: 4%;
                padding-right: 4%;
            }

            .RequirementsContainer{
                .Left{
                    display: flex;
                    gap: 10%;
                }

                .Right{
                    display: flex;
                    flex-direction: column;
                }

                .Column{
                    padding-left: 4%;
                    padding-right: 4%;

                    .Black{
                        color: #000;
                        font-family: 'Neue Haas Grotesk Display Pro';
                        font-size: calc(0.2rem + 0.8vw);
                        font-style: normal;
                        font-weight: 500;
                    }

                    .BlueTextContainer{
                        display: flex;
                        flex-direction: column;
                        gap: 0.7rem;

                        color: #34C6F1;
                        font-family: 'Neue Haas Grotesk Display Pro';
                        font-size: calc(0.2rem + 0.8vw);
                        font-style: normal;
                        font-weight: 500;
                        //line-height:  100%;
                    }
                }
            }
            
        }

        .InputsDiv{
            display: flex;
            flex-direction: column;

            .FormTitle{
                color: #000;
                font-family: 'Neue Haas Grotesk Display Pro';
                font-style: normal;
                font-weight: 500;
                font-size: calc(0.7rem + 0.5vw);
    
                margin-top: 1rem;
                margin-bottom: 0.4rem;
            }

            .ResponsiveContainer{
                display: flex;
                gap: 2vw;
             
                .InputsSection{
                    flex-basis: 0;
                    flex-grow: 1;
                    gap: 1.8rem;

                    .PlaceHolder{
                        padding: 0 0.5rem;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        transform: translateY(-20%);
                        font-family: 'Neue Haas Grotesk Display Pro'!important;
                        font-size: calc(0.2rem + 0.7vw);
                        font-style: normal;
                        font-weight: 500;
                        letter-spacing: 0.46px;
                        pointer-events: none;
                    }
                }
            }
        }

        .DisclaimerSection{
            display: flex;
            flex-direction: column;
            width: 60%;

            margin-top: 2.5rem;

            .Paragraph{
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
                margin-top: 0.3rem;
                margin-bottom: 1rem;
                
            }

            .Disclaimer{
                color: #77787B;
                font-family: 'Neue Haas Grotesk Display Pro';
                font-size: calc(0.5rem + 0.5vw);
                font-style: normal;
                font-weight: 500;
                text-align: justify;
                //line-height: 20px; /* 125% */
            }

            .CheckboxRow{
                display: flex;
                gap: 2%;

                .BlackText{
                    color: #000;
                    font-family: 'Neue Haas Grotesk Display Pro';
                    font-size: calc(0.3rem + 0.8vw);
                    font-style: normal;
                    font-weight: 500;
                }
            }

            

          
        }

        .ErrorMessage {
            color: #d9505e;
            font-size: 0.875rem;
            margin-top: 0.25rem;
            padding-left: 0.5rem;
        }

        .TextInputError {
            border-color: #d9505e !important;
        }

        .ErrorsContainer {
            margin: 1rem 0;
            padding: 1rem;
            border-radius: 0.5rem;
            background-color: #fff5f5;
        }
    `;
}
